export default __webpack_public_path__ + "static/media/background.d6c7dd49.svg";